<template>
  <el-dialog :visible.sync="visible" width="900px">
    <template #title>
      <div
        style="font-size: 18px; color: #303133; font-weight: bold; text-align: center;"
      >
        分配逾期案件列表
      </div>
    </template>

    <el-form
      :model="form"
      label-position="left"
      :rules="rules"
      ref="formRef"
      size="mini"
      style="width: 100%; margin: 0 auto;"
    >
      <el-form-item label="选择催收员：" prop="shop_user_id">
        <el-select v-model="form.shop_user_id">
          <el-option
            v-for="item in options"
            :key="item.shop_user_id"
            :label="item.user_name"
            :value="item.shop_user_id"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="分配策略：">
        <el-radio v-model="form.strategy" label="1">催收额度平均分配</el-radio>
      </el-form-item> -->
      <el-table
        ref="multipleTable"
        :data="order.data"
        border
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="order_no" label="订单号" width="120">
        </el-table-column>
        <el-table-column prop="username" label="姓名" width="120">
        </el-table-column>
        <el-table-column prop="repayment_date" label="还款日期">
        </el-table-column>
        <el-table-column prop="yuqi" label="逾期天数"> </el-table-column>
      </el-table>
      <!-- <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="10"
          layout="total, prev,sizes ,pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div> -->
    </el-form>

    <template #footer>
      <div
        style="display: flex;
    justify-content: space-around;
    align-items: flex-end;"
      >
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
            :current-page="curPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, prev,sizes ,pager, next, jumper"
            :total="totalDataNumber"
          ></el-pagination>
        </div>
        <div class="d-c-c d-r">
          <el-button @click="cancel" size="mini">取消</el-button>
          <el-button type="primary" @click="submit" size="mini">确定</el-button>
        </div>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import useApi from "@/api/useApi.js";

const options = [];
const order = [];

const rules = {
  shop_user_id: [{ required: true, message: "*请选择催收员", trigger: "blur" }],
  order_id: [
    { required: true, message: "*请选择待分配案件列表", trigger: "blur" }
  ]
};
const form = { shop_user_id: "", order_id: "" };

const baseData = {
  form,
  rules,
  visible: false,
  multipleSelection: [],
  /*一页多少条*/
  pageSize: 10,
  /*一共多少条数据*/
  totalDataNumber: 0,
  /*当前是第几页*/
  curPage: 1
};

export default {
  name: "buyModel",
  props: {},
  data() {
    return { options, order, ...baseData };
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.initList();
    },
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.initList();
    },
    handleSelectionChange(val) {
      let dxlist = "";
      for (let dxdata of val) {
        dxlist += dxdata.order_id + ",";
      }
      this.form.order_id = dxlist;
    },
    init: function(data) {
      this.visible = true;
      this.initInfo();
      this.initList();
    },
    cancel: function() {
      this.visible = false;
      this.form = {
        shop_user_id: "",
        order_id: ""
      };
    },
    submit: async function() {
      this.$refs.formRef.validate(valid => {
        console.log(valid, "validate");
        if (!valid) return;
        this.submitInfo();
      });
    },
    submitInfo: async function() {
      console.log(this.form, "form");
      const { data } = await useApi().getCollectionBindAuthUser(this.form);
      console.log(data, "data");
      this.$message({
        message: "绑定成功",
        type: "success"
      });
      this.$emit("parent-method");
      this.visible = false;
      this.form = {
        shop_user_id: "",
        order_id: ""
      };
    },
    initInfo: async function() {
      const { data } = await useApi().getCollectionUserList({});
      this.options = data;
    },
    initList: async function() {
      let self = this;
      let Params = {
        page: self.curPage,
        list_rows: self.pageSize
      };
      const { data } = await useApi().getCollectionChangeList(Params);
      console.log(data, "data111");
      self.totalDataNumber = data.total;
      self.order = data;
    }
  },
  created() {},
  mounted() {
    this.initInfo();
    this.initList();
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/collection/allocated_cases/component/allocatedModel.vue